class ProductFinder {
  constructor(container) {
    this.container = container;
    this.quiz = container.querySelector('[data-quiz]');
    this.progressBar = container.querySelector('[data-progress-bar]');
    this.questionsContainer = container.querySelector('[data-questions-container]');
    this.resultContainer = container.querySelector('[data-result]');
    this.resultProduct = container.querySelector('[data-result-product]');
    this.restartBtn = container.querySelector('[data-restart]');

    this.questions = Array.from(this.questionsContainer.querySelectorAll('[data-question]'));
    this.currentQuestion = 0;
    this.answers = {};
    this.totalQuestions = this.questions.length;

    // Product mapping based on answers
    this.productMap = window.productFinderMap || {};

    this.init();
  }

  init() {
    this.bindEvents();
    this.updateProgress();
  }

  bindEvents() {
    this.questions.forEach((question, index) => {
      const options = question.querySelectorAll('[data-value]');
      options.forEach(option => {
        option.addEventListener('click', () => {
          this.handleAnswer(index, option.dataset.value);
        });
      });
    });

    if (this.restartBtn) {
      this.restartBtn.addEventListener('click', () => this.restart());
    }
  }

  handleAnswer(questionIndex, value) {
    this.answers[`q${questionIndex + 1}`] = value;
    this.currentQuestion++;

    if (this.currentQuestion < this.totalQuestions) {
      this.showQuestion(this.currentQuestion);
      this.updateProgress();
    } else {
      this.showResult();
    }
  }

  showQuestion(index) {
    this.questions.forEach((q, i) => {
      q.style.display = i === index ? 'block' : 'none';
    });
  }

  updateProgress() {
    const progress = (this.currentQuestion / this.totalQuestions) * 100;
    this.progressBar.style.width = `${progress}%`;
  }

  async showResult() {
    this.updateProgress();

    // Hide questions
    this.questionsContainer.style.display = 'none';

    // Determine recommended product
    const productHandle = this.determineProduct();

    if (productHandle) {
      await this.fetchAndDisplayProduct(productHandle);
    } else {
      this.showFallbackResult();
    }

    // Show result
    this.resultContainer.style.display = 'block';
  }

  determineProduct() {
    // Create a signature from answers
    const signature = Object.values(this.answers).join('-').toLowerCase();

    // Check product map for matching signature
    for (const [key, handle] of Object.entries(this.productMap)) {
      if (signature.includes(key.toLowerCase())) {
        return handle;
      }
    }

    // Fallback logic based on common patterns
    const answerStr = signature;

    // Example logic - customize based on your products
    if (answerStr.includes('performance') || answerStr.includes('energy')) {
      return this.productMap.performance || this.productMap.default;
    } else if (answerStr.includes('taste') || answerStr.includes('flavor')) {
      return this.productMap.taste || this.productMap.default;
    } else if (answerStr.includes('recovery') || answerStr.includes('muscle')) {
      return this.productMap.recovery || this.productMap.default;
    }

    return this.productMap.default;
  }

  async fetchAndDisplayProduct(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      const product = await response.json();

      const html = `
        <img src="${product.featured_image}" alt="${product.title}">
        <h4>${product.title}</h4>
        <p>${product.description.substring(0, 150)}...</p>
        <p class="product-finder__result-price">${this.formatMoney(product.price)}</p>
        <a href="${product.url}" class="button">View Product</a>
      `;

      this.resultProduct.innerHTML = html;
    } catch (error) {
      console.error('Error fetching product:', error);
      this.showFallbackResult();
    }
  }

  showFallbackResult() {
    this.resultProduct.innerHTML = `
      <h4>We have the perfect product for you!</h4>
      <p>Based on your answers, we recommend checking out our full range.</p>
      <a href="/collections/all" class="button">View All Products</a>
    `;
  }

  formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  }

  restart() {
    this.currentQuestion = 0;
    this.answers = {};
    this.questionsContainer.style.display = 'block';
    this.resultContainer.style.display = 'none';
    this.showQuestion(0);
    this.updateProgress();
  }
}

// Auto-initialize
document.addEventListener('DOMContentLoaded', () => {
  const finders = document.querySelectorAll('.product-finder');
  finders.forEach(finder => {
    new ProductFinder(finder);
  });
});

// Re-initialize after Shopify section editor updates
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const finder = event.target.querySelector('.product-finder');
    if (finder) {
      new ProductFinder(finder);
    }
  });
}
